import { render, staticRenderFns } from "./CompositionsJudge.vue?vue&type=template&id=60a580d6&lang=pug&"
import script from "./CompositionsJudge.vue?vue&type=script&lang=js&"
export * from "./CompositionsJudge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports